import {
  Grid,
  Box,
  TextField,
  Button,
  MenuItem,
} from "@material-ui/core";
import { useState, useEffect } from "react";
import Axios from "axios";
import { useNavigate, useParams } from "react-router-dom";
import { Helmet } from "react-helmet";

import { Loading } from "../../components/shared/loading";
import { useAdminStyles } from "../../components/admin/adminStyles";
import { AdminPageHeader } from "../../components/admin/AdminPageHeader";
import { useToast } from "../../components/shared/Toast";

import SaveIcon from "@material-ui/icons/Save";

const headKey = "qweqeasdj123n1jasndjn2j3njsdn12i891bdjsdu1283djsd1231231";

const PAGE_OPTIONS = [
  { value: 1, label: "Home" },
  { value: 2, label: "Services" },
  { value: 3, label: "Products" },
  { value: 4, label: "Our Works" },
  { value: 5, label: "Contact Us" },
  { value: 6, label: "About Us" },
  { value: 7, label: "What's New" },
  { value: 8, label: "Our Team" },
];

export const UpdateMetaData = () => {
  const classes = useAdminStyles();
  const navigate = useNavigate();
  const toast = useToast();
  const { id } = useParams();

  const [isLoading, setIsLoading] = useState(true);
  const [title, setTitle] = useState("");
  const [keywords, setKeywords] = useState("");
  const [metadesc, setMetaDesc] = useState("");
  const [page, setPage] = useState("");

  const [err, setErr] = useState(0);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    const formData = new FormData();
    formData.append("idd", id);
    Axios.post("/api/getmetadataadmin", formData, {
      headers: { headKey: headKey },
    }).then((res) => {
      if (res.data.status) {
        const d = res.data.data;
        setTitle(d.meta_title || "");
        setKeywords(d.meta_keywords || "");
        setMetaDesc(d.meta_desc || "");
        setPage(d.meta_page || "");
        setIsLoading(false);
      } else {
        toast.error("Could not load metadata");
        navigate("/dash/allmetadatas");
      }
    });
  }, [id, navigate, toast]);

  const onSubmit = () => {
    setErr(0);
    if (!title.trim()) {
      setErr(4);
      toast.error("Please enter the meta title.");
      return;
    }
    if (!keywords.trim()) {
      setErr(5);
      toast.error("Please enter meta keywords.");
      return;
    }
    if (!metadesc.trim()) {
      setErr(6);
      toast.error("Please enter the meta description.");
      return;
    }
    if (page === "" || page === null) {
      setErr(7);
      toast.error("Please select a target page.");
      return;
    }

    setSubmitting(true);
    const formData = new FormData();
    formData.append("metaid", id);
    formData.append("metapage", page);
    formData.append("metatitle", title.trim());
    formData.append("metakey", keywords.trim());
    formData.append("metadesc", metadesc.trim());

    Axios.post("/api/updatemetadata", formData, {
      headers: { headKey: headKey },
    })
      .then((res) => {
        setSubmitting(false);
        if (res.data.status) {
          toast.success(res.data.msg || "Metadata updated");
          navigate("/dash/allmetadatas");
        } else {
          toast.error(res.data.msg || "Something went wrong. Try again.");
        }
      })
      .catch(() => {
        setSubmitting(false);
        toast.error("Network error. Please try again.");
      });
  };

  if (isLoading) return <Loading />;

  return (
    <div>
      <Helmet>
        <title>Edit Metadata - Admin | Arawinz Soft Solutions</title>
      </Helmet>

      <AdminPageHeader
        eyebrow="SEO"
        title="Edit metadata"
        subtitle="Update the SEO meta tags for the selected page."
        backTo="/dash/allmetadatas"
      />

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <TextField
            label="Meta title"
            variant="outlined"
            error={err === 4}
            value={title}
            size="small"
            onChange={(e) => setTitle(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            select
            label="For page"
            variant="outlined"
            error={err === 7}
            value={page}
            size="small"
            onChange={(e) => setPage(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          >
            <MenuItem value="">Select page...</MenuItem>
            {PAGE_OPTIONS.map((p) => (
              <MenuItem key={p.value} value={p.value}>
                {p.label}
              </MenuItem>
            ))}
          </TextField>
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Meta keywords"
            variant="outlined"
            error={err === 5}
            value={keywords}
            size="small"
            multiline
            rows={4}
            onChange={(e) => setKeywords(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
            placeholder="comma, separated, keywords"
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            label="Meta description"
            variant="outlined"
            error={err === 6}
            value={metadesc}
            size="small"
            multiline
            rows={4}
            onChange={(e) => setMetaDesc(e.target.value)}
            required
            fullWidth
            className={classes.textField}
            InputLabelProps={{ shrink: true }}
          />
        </Grid>
      </Grid>

      <Box className={classes.formFooter}>
        <Button
          className={classes.secondaryBtn}
          onClick={() => navigate("/dash/allmetadatas")}
        >
          Cancel
        </Button>
        <Button
          onClick={onSubmit}
          disabled={submitting}
          className={classes.primaryBtn}
          startIcon={!submitting && <SaveIcon />}
        >
          {submitting ? "Saving..." : "Save changes"}
        </Button>
      </Box>
    </div>
  );
};
